<div class="table-toolbar">
  
  <div *ngIf="isReadonly && editableCsSetupSection.allProductsUpToDate">
    <button mat-icon-button color="accent" (click)="deleteCsSetup()">
      <mat-icon>delete</mat-icon>
    </button>
    <button mat-icon-button color="accent" (click)="startEdit()">
      <mat-icon>edit</mat-icon>
    </button>
  </div>

  <div *ngIf="isReadonly && !editableCsSetupSection.allProductsUpToDate">
    <mat-slide-toggle [checked]="editableCsSetupSection.displayProductUpdates"
                      (change)="editableCsSetupSection.onDisplayProductUpdatesChanged($event.source.checked)">
      <div class="slideToggleLabel">
        ÄNDERUNGEN ANZEIGEN
      </div>
    </mat-slide-toggle>

    <div *ngIf="editableCsSetupSection.containsOutdatedProduct" class="display-inline-block">
      <button mat-button
              class="applyProductUpdatesButton" 
              color="accent"
              [disabled]="!editableCsSetupSection.displayProductUpdates"
              (click)="alignEntriesToCurrentProducts()">
        <mat-icon>done</mat-icon>
        ÄNDERUNGEN ÜBERNEHMEN
      </button>
      <mat-icon class="info-icon" 
                color="primary"
                matTooltipPosition="above"
                matTooltip="Die Artikelstammdaten haben sich geändert. Die Änderungen können durch einen Klick auf &quot;ÄNDERUNGEN ANZEIGEN&quot; 
                  sichtbar gemacht und anschließend mit &quot;ÄNDERUNGEN ÜBERNEHMEN&quot; übernommen werden.
                  Diese Tabelle kann erst wieder bearbeitet werden nachdem die Änderungen der Artikelstammdaten übernommen wurden.">
        info_outline
      </mat-icon>
    </div>
    
    <div *ngIf="editableCsSetupSection.containsDeletedProduct" class="display-inline-block">
      <button mat-button 
              color="accent" 
              class="applyProductUpdatesButton"
              [disabled]="!editableCsSetupSection.displayProductUpdates"
              (click)="alignEntriesToCurrentProducts()">
        <mat-icon>done</mat-icon>
        ÄNDERUNGEN ÜBERNEHMEN
      </button>
      <mat-icon class="info-icon"
                color="primary"
                matTooltipPosition="above"
                matTooltip="Die Artikelstammdaten haben sich geändert. Diese Tabelle enthält unter anderem Artikel, die gelöscht wurden.
                  Die Änderungen können durch einen Klick auf &quot;ÄNDERUNGEN ANZEIGEN&quot; 
                  sichtbar gemacht und anschließend mit &quot;ÄNDERUNGEN ÜBERNEHMEN&quot; übernommen werden.
                  Diese Tabelle kann erst wieder bearbeitet werden nachdem die Änderungen der Artikelstammdaten übernommen wurden.">
        info_outline
      </mat-icon>
    </div>

    <div *ngIf="editableCsSetupSection.containsDeletedChargingStation"  class="display-inline-block">
      <button mat-button 
              color="accent" 
              class="applyProductUpdatesButton"
              (click)="deleteCsSetup(true)"
              [disabled]="!editableCsSetupSection.displayProductUpdates">
        <mat-icon>done</mat-icon>
        ÄNDERUNGEN ÜBERNEHMEN
      </button>
      <mat-icon class="info-icon" 
                color="primary"
                matTooltipPosition="above"
                matTooltip="Die Artikelstammdaten haben sich geändert. Diese Tabelle enthält eine Ladestation, die gelöscht wurde.
                Die Änderungen können durch einen Klick auf &quot;ÄNDERUNGEN ANZEIGEN&quot; 
                sichtbar gemacht und anschließend mit &quot;ÄNDERUNGEN ÜBERNEHMEN&quot; übernommen werden.
                Diese Tabelle kann erst wieder bearbeitet werden nachdem die Änderungen der Artikelstammdaten übernommen wurden.">
        info_outline
      </mat-icon>
    </div>
  </div>
  
  <div *ngIf="!isReadonly">
    <button mat-icon-button *ngIf="!isReadonly" color="accent" (click)="discardChanges()">
      <mat-icon>clear</mat-icon>
    </button>
    <button mat-icon-button *ngIf="!isReadonly" color="accent" [disabled]="csSetupForm.invalid" (click)="saveChanges()">
      <mat-icon>done</mat-icon>
    </button>
    <mat-icon *ngIf="csSetupForm.invalid" 
              class="info-icon" 
              color="primary"
              matTooltipPosition="above"
              matTooltip="Alle Werte in der Spalte &quot;Rabatt&quot; müssen zwischen 0 und 100 liegen.">
      info_outline
    </mat-icon>
  </div>
  
</div>

<form #csSetupForm="ngForm">
  <mat-table
         #csSetupTable
         class="section-table" 
         [dataSource]="editableCsSetupSection.entries$"
         cdkDropList
         [cdkDropListSortPredicate]="editableCsSetupSection.sortPredicate"
         (cdkDropListDropped)="editableCsSetupSection.onDrop($event)">
    <!-- Internal Id Column -->
    <ng-container matColumnDef="productId">
      <mat-header-cell *matHeaderCellDef> Art. Nr. </mat-header-cell>
      <mat-cell 
          *matCellDef="let csSetupItem; let rowIdx = index;"
          [class.productDeleted] = "editableCsSetupSection.displayProductUpdates && csSetupItem.relatedProductWasDeleted"
          [class.move-cursor]="!isReadonly && rowIdx > 0"
          (mousedown)="dragDisabled = isReadonly || rowIdx === 0"> 
          <mat-icon *ngIf="!isReadonly && rowIdx > 0" class="row-reorder-icon">height</mat-icon>
          {{csSetupItem.product?.id}}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
    </ng-container>
  
    <!-- Quantity Column -->
    <ng-container matColumnDef="quantity">
      <mat-header-cell *matHeaderCellDef> Menge </mat-header-cell>
      <mat-cell class="right-aligned-cell" *matCellDef="let csSetupItem; let rowIdx = index;">
        
        <div *ngIf="csSetupItem.entryType === editableCsSetupSection.entryTypes.ChargingStation">
          <div *ngIf="isReadonly; else editableCsQuantity"
               class="align-to-numeric-cell-input"
               [class.productDeleted] = "editableCsSetupSection.displayProductUpdates && csSetupItem.relatedProductWasDeleted">
            {{editableCsSetupSection.csQuantity}}
          </div>
          <ng-template #editableCsQuantity>
            <div>
              <input matInput 
                    #name="ngModel"
                    name="quantity{{rowIdx}}"
                    class="editable-cell numeric-cell-input"
                    type="number" 
                    [(ngModel)]="editableCsSetupSection.csQuantity">
            </div>
          </ng-template>
        </div>
        
        <div *ngIf="csSetupItem.entryType === editableCsSetupSection.entryTypes.CsOptionalFeature"
             class="align-to-numeric-cell-input"
             [class.productDeleted] = "editableCsSetupSection.displayProductUpdates && csSetupItem.relatedProductWasDeleted">
          {{editableCsSetupSection.csQuantity}}
        </div>
        
        <div *ngIf="csSetupItem.entryType === editableCsSetupSection.entryTypes.CsCustomFeature">
          <div *ngIf="isReadonly; else editableCsQuantity"
               class="align-to-numeric-cell-input"
               [class.productDeleted] = "editableCsSetupSection.displayProductUpdates && editableCsSetupSection.containsDeletedChargingStation">
            {{csSetupItem.quantity}}
          </div>
          <ng-template #editableCsQuantity>
            <input matInput 
                  #name="ngModel"
                  name="customFeatureQuantity{{rowIdx}}"
                  class="editable-cell numeric-cell-input" 
                  type="number" 
                  [(ngModel)]="csSetupItem.quantity">
          </ng-template>
        </div>
        
      </mat-cell>
      <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
    </ng-container>
  
    <!-- Discount Column -->
    <ng-container matColumnDef="discountFactor">
      <mat-header-cell *matHeaderCellDef> Rabatt [%] </mat-header-cell>
      <mat-cell class="right-aligned-cell" *matCellDef="let csSetupItem; let rowIdx = index;"> 
        <div>
          <div *ngIf="isReadonly"
             class="align-to-numeric-cell-input"
             [class.productDeleted] = "editableCsSetupSection.displayProductUpdates && (editableCsSetupSection.containsDeletedChargingStation || csSetupItem.relatedProductWasDeleted)">
             {{csSetupItem.discountFactor * 100}}
          </div> 
          <div *ngIf="!isReadonly"> 
            <input matInput 
                  #discountFactor="ngModel"
                  name="discountFactor{{rowIdx}}"
                  class="editable-cell numeric-cell-input"
                  [ngClass]="discountFactor.invalid ? 'editable-cell numeric-cell-input invalid-value' : 'editable-cell numeric-cell-input'"
                  type="number" 
                  min="0" 
                  max="100" 
                  step="10"
                  pattern="(^100$)|(^[0-9]{1,2}$)"
                  required
                  [ngModel]="csSetupItem.discountFactor * 100 "
                  (ngModelChange)="csSetupItem.discountFactor=$event / 100">
          </div>
        </div>
      </mat-cell >
      <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
    </ng-container>
  
    <!-- Description Column --> 
    <ng-container matColumnDef="description">
      <mat-header-cell *matHeaderCellDef> Beschreibung </mat-header-cell>
      <mat-cell  *matCellDef="let csSetupItem; let rowIdx = index;"> 
        <div class="width-100-percent">
          <!-- Charging Station --> 
          <div *ngIf="csSetupItem.entryType === editableCsSetupSection.entryTypes.ChargingStation"
                [class.productDeleted] = "editableCsSetupSection.displayProductUpdates && csSetupItem.relatedProductWasDeleted">
            <div *ngIf="isReadonly; else editableChargingStation"> 
              <div *ngIf="editableCsSetupSection.displayProductUpdates && csSetupItem.relatedProductWasUpdated">
                {{csSetupItem.latestProduct.name}}
              </div>
              <div [class.productOutdated] = "editableCsSetupSection.displayProductUpdates && csSetupItem.relatedProductWasUpdated">
                {{csSetupItem.product.name}}
              </div>
            </div>
            <ng-template #editableChargingStation>
              <mat-select class="product-select" 
                          [value]="csSetupItem.product.id"
                          (selectionChange)="editableCsSetupSection.onChargingStationSelected(csSetupItem, $event.value)">
                <mat-option *ngFor="let chargingStation of chargingStations" [value]="chargingStation.id">
                  {{chargingStation.name}}
                </mat-option>
              </mat-select>
            </ng-template> 
          </div>
  
          <!-- Charging Station Feature-->
          <div *ngIf="csSetupItem.entryType === editableCsSetupSection.entryTypes.CsOptionalFeature"
                [class.productDeleted] = "editableCsSetupSection.displayProductUpdates && csSetupItem.relatedProductWasDeleted">
            <div *ngIf="isReadonly; else editableChargingStationFeature"> 
              <div *ngIf="editableCsSetupSection.displayProductUpdates && csSetupItem.relatedProductWasUpdated">
                {{csSetupItem.latestProduct.name}}
              </div>
              <div [class.productOutdated] = "editableCsSetupSection.displayProductUpdates && csSetupItem.relatedProductWasUpdated">
                {{csSetupItem.product.name}}
              </div>
            </div>
            <ng-template #editableChargingStationFeature> 
              <mat-select #optionalFeatureSelect 
                          class="product-select"
                          [value]="csSetupItem.product.id"
                          (selectionChange)="editableCsSetupSection.onOptionalFeatureSelected(csSetupItem, $event.value)">
                <mat-option *ngFor="let feature of editableCsSetupSection.selectedChargingStation.optionalFeatures"
                            [value]="feature.id">
                  <mat-icon *ngIf="optionalFeatureSelect.panelOpen"
                            [ngStyle]="{'visibility': editableCsSetupSection.isAlreadyPartOfCsSetup(feature.id) ? 'visible' : 'hidden' }">
                    done
                  </mat-icon>
                  {{feature.name}}
                </mat-option>
              </mat-select>
            </ng-template> 
          </div>
              
          <!-- Custom Feature -->
          <div *ngIf="csSetupItem.entryType === editableCsSetupSection.entryTypes.CsCustomFeature">
            <div *ngIf="isReadonly; else editableCustomFeature"
                [class.productDeleted] = "editableCsSetupSection.displayProductUpdates && editableCsSetupSection.containsDeletedChargingStation"> 
              {{csSetupItem.description}} 
            </div>
            <ng-template #editableCustomFeature> 
              <input matInput class="editable-cell"
                     [maxlength]="MAX_CUSTOM_ENTRY_DESCRIPTION_LENGTH"
                     [ngModel]="csSetupItem.description"
                     (ngModelChange)="csSetupItem.description=$event"
                     name="customEntryDescription{{rowIdx}}"
                     type="text" />
            </ng-template> 
          </div>
        </div>
      </mat-cell >
      <mat-footer-cell *matFooterCellDef>
        <div class="width-100-percent">
          <button mat-button
                  *ngIf="!isReadonly && editableCsSetupSection.hasOptionalFeatures"
                  type="button"
                  class="add-prduct-button"
                  color="accent"
                  (click)="editableCsSetupSection.addOptionalFeature()">
            <mat-icon>add</mat-icon>
            OPTION HINZUFÜGEN
          </button>
          <button mat-button *ngIf="!isReadonly" type="button" class="add-custom-position-button" color="accent" (click)="editableCsSetupSection.addCustomEntry()">
            <mat-icon>add</mat-icon>
            BENUTZERDEFINIERTE POSITION HINZUFÜGEN
          </button>
        </div>
      </mat-footer-cell>
    </ng-container>
  
    <!-- Price Per Unit Column -->
    <ng-container matColumnDef="pricePerUnit">
      <mat-header-cell *matHeaderCellDef [ngClass]="'right-aligned-cell'"> Einzelpreis </mat-header-cell>
      <mat-cell class="right-aligned-cell" *matCellDef="let csSetupItem; let rowIdx = index;">
        <div *ngIf="isReadonly || csSetupItem.entryType !== editableCsSetupSection.entryTypes.CsCustomFeature"> 
          <div *ngIf="editableCsSetupSection.displayProductUpdates && csSetupItem.relatedProductWasUpdated">
            {{csSetupItem.getPricePerUnit(true) | currency}}
          </div>
          <div [class.productOutdated] = "editableCsSetupSection.displayProductUpdates && csSetupItem.relatedProductWasUpdated"
               [class.productDeleted] = "editableCsSetupSection.displayProductUpdates && (editableCsSetupSection.containsDeletedChargingStation || csSetupItem.relatedProductWasDeleted)">
            {{csSetupItem.pricePerUnit | currency}} 
          </div>
        </div> 
        <div *ngIf="!isReadonly && csSetupItem.entryType === editableCsSetupSection.entryTypes.CsCustomFeature"
             class="display-inline-flex"> 
          <input matInput 
                 #name="ngModel"
                 name="pricePerUnit{{rowIdx}}"
                 class="numeric-cell-input price-per-unit-input editable-cell" 
                 type="number"
                 [(ngModel)]="csSetupItem.pricePerUnit" />
          <label class="currency-label">€</label>
        </div>
      </mat-cell >
      <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
    </ng-container>

    <!-- AP Column -->
    <ng-container matColumnDef="ap">
      <mat-header-cell *matHeaderCellDef> AP </mat-header-cell>
      <mat-cell *matCellDef="let csSetupItem; let rowIdx = index;"> 
        <mat-checkbox 
          name="isAlternative{{rowIdx}}"
          [disabled]="isReadonly" 
          [(ngModel)]="csSetupItem.isAlternative"></mat-checkbox>
      </mat-cell >
      <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
    </ng-container>
  
    <!-- Total Cost Column -->
    <ng-container matColumnDef="totalCost">
      <mat-header-cell [ngClass]="'right-aligned-cell'" *matHeaderCellDef> Gesamtkosten </mat-header-cell>
      <mat-cell class="right-aligned-cell" 
          *matCellDef="let csSetupItem" 
          [class.alternative-position-price] = "csSetupItem.isAlternative">
        <div *ngIf="csSetupItem.entryType !== editableCsSetupSection.entryTypes.CsCustomFeature; else cutomFeatureTotalCost">
          <div *ngIf="editableCsSetupSection.displayProductUpdates && csSetupItem.relatedProductWasUpdated">
            {{csSetupItem.getTotalCosts(true, editableCsSetupSection.csQuantity) | currency}}
          </div>
          <div [class.productOutdated] = "editableCsSetupSection.displayProductUpdates && csSetupItem.relatedProductWasUpdated"
                [class.productDeleted] = "editableCsSetupSection.displayProductUpdates && csSetupItem.relatedProductWasDeleted">
            {{csSetupItem.getTotalCosts(false, editableCsSetupSection.csQuantity) | currency}}
          </div>
        </div>
        <ng-template #cutomFeatureTotalCost>
          <div [class.productDeleted] = "editableCsSetupSection.displayProductUpdates && editableCsSetupSection.containsDeletedChargingStation">
            {{editableCsSetupSection.getEntryTotalCosts(csSetupItem, csSetupItem.quantity) | currency}}
          </div>
        </ng-template> 
      </mat-cell >
      <mat-footer-cell class="right-aligned-cell" *matFooterCellDef> 
        {{editableCsSetupSection.totalCosts | currency}}
      </mat-footer-cell>
    </ng-container>
  
    <!-- Delete Row Column -->
    <ng-container matColumnDef="delete">
      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
      <mat-cell *matCellDef="let csSetupItem"> 
        <button mat-icon-button *ngIf="!isReadonly && csSetupItem.entryType !== editableCsSetupSection.entryTypes.ChargingStation" type="button" color="accent" (click)="editableCsSetupSection.removeEntry(csSetupItem)">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
      <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
    </ng-container>
    
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row 
        *matRowDef="let row; columns: displayedColumns;"
        cdkDrag 
        cdkDragLockAxis="y"
        [cdkDragDisabled]="dragDisabled">
        <div *cdkDragPlaceholder></div>
    </mat-row>
    <mat-footer-row *matFooterRowDef="displayedColumns"></mat-footer-row>
  </mat-table>
</form>



